export const getSearchParams = () => {
  return new URLSearchParams(window.location.search);
};
